/**
 * Hàng chip lọc tiện ích (bãi xe, ban công, thang máy...).
 *
 * Toggle giá trị '1' / rỗng trên object filters tìm kiếm.
 */
import { AMENITY_FILTER_FIELDS } from '../../shared/constants/property';

const AmenityIcon = ({ type }) => {
  const icons = {
    has_parking: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M5 17h2l1.2-4.5h9.6L19 17h2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="7.5" cy="17.5" r="1.5" />
        <circle cx="16.5" cy="17.5" r="1.5" />
        <path d="M5 12h14l-1.5-5H7L5 12z" strokeLinejoin="round" />
      </svg>
    ),
    has_balcony: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M4 18h16M6 18V9l6-4 6 4v9" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 14h4" strokeLinecap="round" />
      </svg>
    ),
    has_elevator: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <rect x="7" y="3" width="10" height="18" rx="2" />
        <path d="M12 8v8M9.5 12.5 12 15l2.5-2.5M9.5 11.5 12 9l2.5 2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    has_garden: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M12 21V11" strokeLinecap="round" />
        <path d="M8 14c-2-1-3-4-2-7 2 1 4 3 4 7M16 14c2-1 3-4 2-7-2 1-4 3-4 7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    has_swimming_pool: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M4 12c2 2 4 2 6 0s4-2 6 0 4 2 6 0" strokeLinecap="round" />
        <path d="M4 16c2 2 4 2 6 0s4-2 6 0 4 2 6 0" strokeLinecap="round" />
        <path d="M8 6c0-2 1.5-3 4-3s4 1 4 3" strokeLinecap="round" />
      </svg>
    ),
    has_security: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M12 3 5 6v6c0 4.2 3 7.8 7 9 4-1.2 7-4.8 7-9V6l-7-3z" strokeLinejoin="round" />
        <path d="M9.5 12 11 13.5 14.5 10" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  };

  return <span className="search-filter-amenity__icon">{icons[type] || icons.has_parking}</span>;
};

/**
 * Chip lọc tiện ích trong bộ lọc tìm kiếm.
 * @param {Object} props
 * @param {Object} props.filters
 * @param {Function} props.onUpdateFilter
 * @param {string} [props.className]
 */
export const FilterAmenityChips = ({ filters, onUpdateFilter, className = '' }) => (
  <div className={`search-filter-amenity-row ${className}`.trim()}>
    {AMENITY_FILTER_FIELDS.map(({ field, label }) => {
      const isActive = filters[field] === '1' || filters[field] === true;

      return (
        <button
          key={field}
          type="button"
          className={`search-filter-amenity ${isActive ? 'is-active' : ''}`.trim()}
          aria-pressed={isActive}
          onClick={() => onUpdateFilter(field, isActive ? '' : '1')}
        >
          <AmenityIcon type={field} />
          <span>{label}</span>
        </button>
      );
    })}
  </div>
);
